export default "__VITE_ASSET__BVu0uuDR__"